<template>
  <div class="homepage">
    <TopBar />
    <ImageSlider />
    <section class="about">
      <h2>Sobre a Associação</h2>
      <p>A Associação de Karate promove a prática, valores e cultura do Karate em Portugal, com vários dojos e uma equipa dedicada.</p>
    </section>
    <Sponsors />
    <Footer />
  </div>
</template>

<script>
import TopBar from '../components/TopBar.vue';
import ImageSlider from '../components/ImageSlider.vue';
import Footer from '../components/Footer.vue';
import Sponsors from '../components/Sponsors.vue';

export default {
  name: 'Home',
  components: { TopBar, ImageSlider, Footer, Sponsors },
};
</script>

<style scoped>
.homepage {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.about {
  padding: 2rem;
  background: #f7f7f7;
  text-align: center;
}

@media (max-width: 480px) {
  .about {
    padding: 1.5rem 1rem;
  }
  .about h2 {
    font-size: 1.3rem;
  }
  .about p {
    font-size: 0.95rem;
  }
}
</style>

